<div class ="placeholder-main-container" [ngStyle]="{'height': placeholderHeight  + '%'}">
  {{title}}
</div>
